<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">{{'Add Dealer Group Branded Style' | translate | async}}</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>


  <div class="ttmodal__body" [class.hidden]="loadingData">
      <div class="input-container">
          <span class="label">{{'Dealer Group' | translate | async}}<span class="red-text">*</span></span>
          <span class="input-icon input-icon--mat">
              <i class="material-icons">style</i>
          </span>
          <select [(ngModel)]="selectedDealerGroupId" (change)="dealerGroupSelected($event.target.value)" required  class="get-Input">
            <option value="" disabled selected>{{'Select Dealer Group' | translate | async}}</option>
            <option *ngFor="let dealergroup of dealergroups" [value]="dealergroup.Id">{{dealergroup.Name}}</option>
        </select>
      </div>
      <div class="input-container">
          <span class="label">{{'Colour Scheme' | translate | async}} <span class="red-text">*</span></span>
          <span class="input-icon input-icon--mat">
              <i class="material-icons">format_color_fill</i>
          </span>
          <select [(ngModel)]="selectedColourSchemeId" required class="get-Input">
              <option value="" disabled selected>{{'Select Colour Scheme' | translate | async}}</option>
              <option *ngFor="let colourScheme of colourSchemes" [value]="colourScheme.Id">{{colourScheme.Name}}</option>
          </select>
      </div>

      <span class="input-description">{{'Upload a logo for the Dealer Group. Recommended 77px by 35px.' | translate | async}} <span class="red-text">*</span></span>
        <input type='file' (change)="onSelectImage($event)">
        <div style="margin-top: 8px;">
            <img *ngIf="imageUrl" [src]="imageUrl" height="70" width="154">
        </div>


  </div>
  <mat-spinner  *ngIf="loadingData"></mat-spinner>
  <div class="ttmodal__footer" [class.hidden]="loadingData">
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">{{'Cancel' | translate | async}}</span></a>
      <a class="button button--primary" (click)="addNewBrandedStyle()"><span class="button__text">{{'Update Branded Style' | translate | async}}</span></a>
  </div>
</div>